import { useParams } from "react-router-dom";
import { ShareImagePage, S, drawBackdrop, fitText, monthYear } from "./SponsorCertificate";

function star(ctx, cx, cy, r) {
  ctx.beginPath();
  for (let i = 0; i < 10; i += 1) {
    const a = (Math.PI / 5) * i - Math.PI / 2, rr = i % 2 ? r * 0.45 : r;
    ctx.lineTo(cx + rr * Math.cos(a), cy + rr * Math.sin(a));
  }
  ctx.closePath(); ctx.fill();
}

function draw(c, d) {
  const ctx = c.getContext("2d"), cx = S / 2, cy = 500;
  drawBackdrop(ctx);
  ctx.fillStyle = "#FFB703"; ctx.beginPath(); ctx.arc(cx, cy, 380, 0, Math.PI * 2); ctx.fill();
  ctx.fillStyle = "#FFFFFF"; ctx.beginPath(); ctx.arc(cx, cy, 350, 0, Math.PI * 2); ctx.fill();
  ctx.strokeStyle = "#00C2CB"; ctx.lineWidth = 8; ctx.setLineDash([18, 14]); ctx.beginPath(); ctx.arc(cx, cy, 320, 0, Math.PI * 2); ctx.stroke(); ctx.setLineDash([]);
  ctx.fillStyle = "#FF70A6"; star(ctx, cx, 280, 54);
  ctx.textAlign = "center"; ctx.fillStyle = "#00A3AB";
  ctx.font = "800 28px 'Plus Jakarta Sans', sans-serif"; ctx.fillText("ADVENTURE ROCK BERMUDA", cx, 385);
  ctx.fillStyle = "#0B132B"; ctx.font = "800 64px Outfit, sans-serif"; ctx.fillText("FOUNDING", cx, 470);
  ctx.font = "800 46px Outfit, sans-serif"; ctx.fillText("ADVENTURE FAMILY", cx, 530);
  ctx.fillStyle = "#FF4D8D"; fitText(ctx, d.family_name, 800, 54, 560); ctx.fillText(d.family_name, cx, 620);
  ctx.fillStyle = "#64748B"; ctx.font = "600 26px 'Plus Jakarta Sans', sans-serif"; ctx.fillText(`Since ${monthYear(d.since)}`, cx, 680);
  ctx.fillStyle = "#0B132B"; ctx.beginPath(); ctx.roundRect(150, 915, S - 300, 130, 40); ctx.fill();
  ctx.fillStyle = "#FFFFFF"; ctx.font = "700 32px 'Plus Jakarta Sans', sans-serif"; ctx.fillText("Proud to be part of the very first chapter", cx, 960);
  ctx.font = "800 34px Outfit, sans-serif"; ctx.fillText("#SupportTheRock", cx, 1020);
}

export default function FoundingBadge() {
  const { token } = useParams();
  return <ShareImagePage endpoint={`/support/founding-badge/${token}`} title="Your Founding Family Badge" paint={draw}
    intro="Thank you for being one of our first families! Download your badge or share it with friends and family."
    fileName={(d) => `adventure-rock-founding-${d.family_name}`}
    shareText={() => "We're a Founding Adventure Family at Adventure Rock Bermuda! #SupportTheRock"}
    footer={() => "Founding Adventure Family is a prepaid membership package with Adventure Rock Bermuda, a privately operated business."} />;
}
